export const MAPBOX_KEY = 'pk.eyJ1IjoiamFjb2JoYW5zb24iLCJhIjoiY204aXd6cWk0MDViZDJrcG9pcnJucGdyNiJ9.EtRytEQRke3NrLVnZazT1g';
export const MAPBOX_GEOCODER_KEY = 'pk.eyJ1IjoiamFjb2JoYW5zb24iLCJhIjoiNlk4VW9GTSJ9.c_DDqGyloxWrbOyJm3qkgg';

export const US_STATES_BOUNDS = [
	{
		state: "All States",
		abrv: "US",
		coordinates: {
			zoom: 3.5,
			rotation: -10,
			center: [
				-98,
				40
			],
			districts: {}
		}
	},
	{
		state: "Alabama",
		abrv: "AL",
		coordinates: {
			zoom: 5.9,
			rotation: -10,
			center: [
				-87.131,
				32.618
			],
			districts: {}
		}
	},
	{
		state: "Alaska",
		abrv: "AK",
		coordinates: {
			zoom: 4.0,
			rotation: -10,
			center: [
				-156.73,
				64.34
			],
			districts: {}
		}
	},
	{
		state: "Arizona",
		abrv: "AZ",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-112.919,
				34.285
			],
			districts: {}
		}
	},
	{
		state: "Arkansas",
		abrv: "AR",
		coordinates: {
			zoom: 6.0,
			rotation: -10,
			center: [
				-92.789,
				34.678
			],
			districts: {}
		}
	},
	{
		state: "California",
		abrv: "CA",
		coordinates: {
			zoom: 4.9,
			rotation: -10,
			center: [
				-120.45,
				37.41
			],
			districts: {}
		}
	},
	{
		state: "Colorado",
		abrv: "CO",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-106.824,
				38.964
			],
			districts: {}
		}
	},
	{
		state: "Connecticut",
		abrv: "CT",
		coordinates: {
			zoom: 7.3,
			rotation: -10,
			center: [
				-73.038,
				41.549
			],
			districts: {}
		}
	},
	{
		state: "Delaware",
		abrv: "DE",
		coordinates: {
			zoom: 7.3,
			rotation: -10,
			center: [
				-75.535,
				39.127
			],
			districts: {}
		}
	},
	{
		state: "District Of Columbia",
		abrv: "DC",
		coordinates: {
			zoom: 10.0,
			rotation: -10,
			center: [
				-77.0521,
				38.8883
			],
			districts: {}
		}
	},
	{
		state: "Florida",
		abrv: "FL",
		coordinates: {
			zoom: 5.4,
			rotation: -10,
			center: [
				-85.01,
				28.186
			],
			districts: {}
		}
	},
	{
		state: "Georgia",
		abrv: "GA",
		coordinates: {
			zoom: 5.7,
			rotation: -10,
			center: [
				-84.058,
				32.576
			],
			districts: {}
		}
	},
	{
		state: "Hawaii",
		abrv: "HI",
		coordinates: {
			zoom: 4.8,
			rotation: -10,
			center: [
				-158.341,
				20.656
			],
			districts: {}
		}
	},
	{
		state: "Idaho",
		abrv: "ID",
		coordinates: {
			zoom: 4.8,
			rotation: -10,
			center: [
				-115.38,
				45.63
			],
			districts: {}
		}
	},
	{
		state: "Illinois",
		abrv: "IL",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-90.277,
				40.013
			],
			districts: {}
		}
	},
	{
		state: "Indiana",
		abrv: "IN",
		coordinates: {
			zoom: 5.8,
			rotation: -10,
			center: [
				-87.343,
				39.726
			],
			districts: {}
		}
	},
	{
		state: "Iowa",
		abrv: "IA",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-94.074,
				42.148
			],
			districts: {}
		}
	},
	{
		state: "Kansas",
		abrv: "KS",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-99.238,
				38.582
			],
			districts: {}
		}
	},
	{
		state: "Kentucky",
		abrv: "KY",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-86.713,
				37.654
			],
			districts: {}
		}
	},
	{
		state: "Louisiana",
		abrv: "LA",
		coordinates: {
			zoom: 5.9,
			rotation: -10,
			center: [
				-92.435,
				31.169
			],
			districts: {}
		}
	},
	{
		state: "Maine",
		abrv: "ME",
		coordinates: {
			zoom: 5.5,
			rotation: -10,
			center: [
				-70.498,
				45.053
			],
			districts: {}
		}
	},
	{
		state: "Maryland",
		abrv: "MD",
		coordinates: {
			zoom: 6.3,
			rotation: -10,
			center: [
				-78.071,
				38.834
			],
			districts: {}
		}
	},
	{
		state: "Massachusetts",
		abrv: "MA",
		coordinates: {
			zoom: 6.5,
			rotation: -10,
			center: [
				-72.171,
				42.24
			],
			districts: {}
		}
	},
	{
		state: "Michigan",
		abrv: "MI",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-87.794,
				44.916
			],
			districts: {}
		}
	},
	{
		state: "Minnesota",
		abrv: "MN",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-94.936,
				46.167
			],
			districts: {}
		}
	},
	{
		state: "Mississippi",
		abrv: "MS",
		coordinates: {
			zoom: 5.7,
			rotation: -10,
			center: [
				-90.784,
				32.363
			],
			districts: {}
		}
	},
	{
		state: "Missouri",
		abrv: "MO",
		coordinates: {
			zoom: 5.3,
			rotation: -10,
			center: [
				-93.554,
				38.427
			],
			districts: {}
		}
	},
	{
		state: "Montana",
		abrv: "MT",
		coordinates: {
			zoom: 4.5,
			rotation: -10,
			center: [
				-111.67,
				46.98
			],
			districts: {}
		}
	},
	{
		state: "Nebraska",
		abrv: "NE",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-100.47,
				41.648
			],
			districts: {}
		}
	},
	{
		state: "Nevada",
		abrv: "NV",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-118.664,
				38.567
			],
			districts: {}
		}
	},
	{
		state: "New Hampshire",
		abrv: "NH",
		coordinates: {
			zoom: 6.0,
			rotation: -10,
			center: [
				-72.415,
				43.795
			],
			districts: {}
		}
	},
	{
		state: "New Jersey",
		abrv: "NJ",
		coordinates: {
			zoom: 6.5,
			rotation: -10,
			center: [
				-75.362,
				40.051
			],
			districts: {}
		}
	},
	{
		state: "New Mexico",
		abrv: "NM",
		coordinates: {
			zoom: 5.3,
			rotation: -10,
			center: [
				-107.152,
				34.213
			],
			districts: {}
		}
	},
	{
		state: "New York",
		abrv: "NY",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-77.172,
				42.948
			],
			districts: {}
		}
	},
	{
		state: "North Carolina",
		abrv: "NC",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-80.82,
				35.466
			],
			districts: {}
		}
	},
	{
		state: "North Dakota",
		abrv: "ND",
		coordinates: {
			zoom: 5.0,
			rotation: -10,
			center: [
				-101.136,
				47.359
			],
			districts: {}
		}
	},
	{
		state: "Ohio",
		abrv: "OH",
		coordinates: {
			zoom: 5.7,
			rotation: -10,
			center: [
				-83.75,
				40.572
			],
			districts: {}
		}
	},
	{
		state: "Oklahoma",
		abrv: "OK",
		coordinates: {
			zoom: 5.3,
			rotation: -10,
			center: [
				-99.301,
				35.526
			],
			districts: {}
		}
	},
	{
		state: "Oregon",
		abrv: "OR",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-121.532,
				44.155
			],
			districts: {}
		}
	},
	{
		state: "Pennsylvania",
		abrv: "PA",
		coordinates: {
			zoom: 5.4,
			rotation: -10,
			center: [
				-78.318,
				41.116
			],
			districts: {}
		}
	},
	{
		state: "Puerto Rico",
		abrv: "PR",
		coordinates: {
			zoom: 6.0,
			rotation: -10,
			center: [
				-66.646,
				18.112
			],
			districts: {}
		}
	},
	{
		state: "Rhode Island",
		abrv: "RI",
		coordinates: {
			zoom: 7.5,
			rotation: -10,
			center: [
				-71.715,
				41.558
			],
			districts: {}
		}
	},
	{
		state: "South Carolina",
		abrv: "SC",
		coordinates: {
			zoom: 6.0,
			rotation: -10,
			center: [
				-81.474,
				33.762
			],
			districts: {}
		}
	},
	{
		state: "South Dakota",
		abrv: "SD",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-101.244,
				44.415
			],
			districts: {}
		}
	},
	{
		state: "Tennessee",
		abrv: "TN",
		coordinates: {
			zoom: 5.3,
			rotation: -10,
			center: [
				-87.175,
				36.015
			],
			districts: {}
		}
	},
	{
		state: "Texas",
		abrv: "TX",
		coordinates: {
			zoom: 4.5,
			rotation: -10,
			center: [
				-101.98,
				31.12
			],
			districts: {}
		}
	},
	{
		state: "Utah",
		abrv: "UT",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-112.822,
				39.328
			],
			districts: {}
		}
	},
	{
		state: "Vermont",
		abrv: "VT",
		coordinates: {
			zoom: 6.0,
			rotation: -10,
			center: [
				-73.363,
				43.692
			],
			districts: {}
		}
	},
	{
		state: "Virginia",
		abrv: "VA",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-80.634,
				37.81
			],
			districts: {}
		}
	},
	{
		state: "Washington",
		abrv: "WA",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-121.621,
				47.5
			],
			districts: {}
		}
	},
	{
		state: "West Virginia",
		abrv: "WV",
		coordinates: {
			zoom: 5.4,
			rotation: -10,
			center: [
				-80.85,
				39.03
			],
			districts: {}
		}
	},
	{
		state: "Wisconsin",
		abrv: "WI",
		coordinates: {
			zoom: 5.3,
			rotation: -10,
			center: [
				-90.621,
				44.654
			],
			districts: {}
		}
	},
	{
		state: "Wyoming",
		abrv: "WY",
		coordinates: {
			zoom: 5.2,
			rotation: -10,
			center: [
				-108.606,
				43.036
			],
			districts: {}
		}
	}
];

export const US_DISTRICTS = [
	{"state": "AK", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "AL", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "AL", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "AL", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "AL", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "AL", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "AL", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "AL", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "AR", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "AR", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "AR", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "AR", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "AZ", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "AZ", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "AZ", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "AZ", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "AZ", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "AZ", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "AZ", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "AZ", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "AZ", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "CA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "CA", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "CA", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "CA", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "CA", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "CA", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "CA", "district_num": "15", "alt_district_val": "15th District"},
	{"state": "CA", "district_num": "16", "alt_district_val": "16th District"},
	{"state": "CA", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "CA", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "CA", "district_num": "19", "alt_district_val": "19th District"},
	{"state": "CA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "CA", "district_num": "20", "alt_district_val": "20th District"},
	{"state": "CA", "district_num": "21", "alt_district_val": "21st District"},
	{"state": "CA", "district_num": "22", "alt_district_val": "22nd District"},
	{"state": "CA", "district_num": "23", "alt_district_val": "23rd District"},
	{"state": "CA", "district_num": "24", "alt_district_val": "24th District"},
	{"state": "CA", "district_num": "25", "alt_district_val": "25th District"},
	{"state": "CA", "district_num": "26", "alt_district_val": "26th District"},
	{"state": "CA", "district_num": "27", "alt_district_val": "27th District"},
	{"state": "CA", "district_num": "28", "alt_district_val": "28th District"},
	{"state": "CA", "district_num": "29", "alt_district_val": "29th District"},
	{"state": "CA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "CA", "district_num": "30", "alt_district_val": "30th District"},
	{"state": "CA", "district_num": "31", "alt_district_val": "31st District"},
	{"state": "CA", "district_num": "32", "alt_district_val": "32nd District"},
	{"state": "CA", "district_num": "33", "alt_district_val": "33rd District"},
	{"state": "CA", "district_num": "34", "alt_district_val": "34th District"},
	{"state": "CA", "district_num": "35", "alt_district_val": "35th District"},
	{"state": "CA", "district_num": "36", "alt_district_val": "36th District"},
	{"state": "CA", "district_num": "37", "alt_district_val": "37th District"},
	{"state": "CA", "district_num": "38", "alt_district_val": "38th District"},
	{"state": "CA", "district_num": "39", "alt_district_val": "39th District"},
	{"state": "CA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "CA", "district_num": "40", "alt_district_val": "40th District"},
	{"state": "CA", "district_num": "41", "alt_district_val": "41st District"},
	{"state": "CA", "district_num": "42", "alt_district_val": "42nd District"},
	{"state": "CA", "district_num": "43", "alt_district_val": "43rd District"},
	{"state": "CA", "district_num": "44", "alt_district_val": "44th District"},
	{"state": "CA", "district_num": "45", "alt_district_val": "45th District"},
	{"state": "CA", "district_num": "46", "alt_district_val": "46th District"},
	{"state": "CA", "district_num": "47", "alt_district_val": "47th District"},
	{"state": "CA", "district_num": "48", "alt_district_val": "48th District"},
	{"state": "CA", "district_num": "49", "alt_district_val": "49th District"},
	{"state": "CA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "CA", "district_num": "50", "alt_district_val": "50th District"},
	{"state": "CA", "district_num": "51", "alt_district_val": "51st District"},
	{"state": "CA", "district_num": "52", "alt_district_val": "52nd District"},
	{"state": "CA", "district_num": "53", "alt_district_val": "53rd District"},
	{"state": "CA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "CA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "CA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "CA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "CO", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "CO", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "CO", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "CO", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "CO", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "CO", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "CO", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "CT", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "CT", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "CT", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "CT", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "CT", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "DC", "district_num": "98", "alt_district_val": "98th District"},
	{"state": "DE", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "FL", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "FL", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "FL", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "FL", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "FL", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "FL", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "FL", "district_num": "15", "alt_district_val": "15th District"},
	{"state": "FL", "district_num": "16", "alt_district_val": "16th District"},
	{"state": "FL", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "FL", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "FL", "district_num": "19", "alt_district_val": "19th District"},
	{"state": "FL", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "FL", "district_num": "20", "alt_district_val": "20th District"},
	{"state": "FL", "district_num": "21", "alt_district_val": "21st District"},
	{"state": "FL", "district_num": "22", "alt_district_val": "22nd District"},
	{"state": "FL", "district_num": "23", "alt_district_val": "23rd District"},
	{"state": "FL", "district_num": "24", "alt_district_val": "24th District"},
	{"state": "FL", "district_num": "25", "alt_district_val": "25th District"},
	{"state": "FL", "district_num": "26", "alt_district_val": "26th District"},
	{"state": "FL", "district_num": "27", "alt_district_val": "27th District"},
	{"state": "FL", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "FL", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "FL", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "FL", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "FL", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "FL", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "FL", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "GA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "GA", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "GA", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "GA", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "GA", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "GA", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "GA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "GA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "GA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "GA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "GA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "GA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "GA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "GA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "HI", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "HI", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "IA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "IA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "IA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "IA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "ID", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "ID", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "IL", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "IL", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "IL", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "IL", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "IL", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "IL", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "IL", "district_num": "15", "alt_district_val": "15th District"},
	{"state": "IL", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "IL", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "IL", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "IL", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "IL", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "IL", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "IL", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "IL", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "IL", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "IN", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "IN", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "IN", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "IN", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "IN", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "IN", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "IN", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "KS", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "KS", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "KS", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "KS", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "KY", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "KY", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "KY", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "KY", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "KY", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "LA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "LA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "LA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "LA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "LA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "LA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "MA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "MA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "MA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "MA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "MD", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "MD", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MD", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MD", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MD", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "MD", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MD", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "MD", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "ME", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "ME", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MI", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "MI", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "MI", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "MI", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "MI", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "MI", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "MI", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MI", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MI", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MI", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "MI", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MI", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "MI", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "MN", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "MN", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MN", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MN", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MN", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "MN", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MN", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "MN", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "MO", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "MO", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MO", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MO", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MO", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "MO", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "MO", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "MO", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "MS", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "MS", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "MS", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "MT", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "NC", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NC", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "NC", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "NC", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "NC", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "NC", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NC", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NC", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "NC", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "NC", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "NC", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "NC", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "NC", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "ND", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "NE", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NE", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NE", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NH", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NH", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NJ", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NJ", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "NJ", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "NJ", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "NJ", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NJ", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NJ", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "NJ", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "NJ", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "NJ", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "NJ", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "NJ", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "NM", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NM", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NM", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NV", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NV", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NV", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NV", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "NY", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "NY", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "NY", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "NY", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "NY", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "NY", "district_num": "16", "alt_district_val": "16th District"},
	{"state": "NY", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "NY", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "NY", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "NY", "district_num": "20", "alt_district_val": "20th District"},
	{"state": "NY", "district_num": "23", "alt_district_val": "23rd District"},
	{"state": "NY", "district_num": "24", "alt_district_val": "24th District"},
	{"state": "NY", "district_num": "25", "alt_district_val": "25th District"},
	{"state": "NY", "district_num": "26", "alt_district_val": "26th District"},
	{"state": "NY", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "NY", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "NY", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "NY", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "NY", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "NY", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "OH", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "OH", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "OH", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "OH", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "OH", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "OH", "district_num": "15", "alt_district_val": "15th District"},
	{"state": "OH", "district_num": "16", "alt_district_val": "16th District"},
	{"state": "OH", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "OH", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "OH", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "OH", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "OH", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "OH", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "OK", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "OK", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "OK", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "OK", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "OK", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "OR", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "OR", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "OR", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "OR", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "OR", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "PA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "PA", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "PA", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "PA", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "PA", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "PA", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "PA", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "PA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "PA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "PA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "PA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "PA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "PA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "PA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "PA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "PR", "district_num": "98", "alt_district_val": "98th District"},
	{"state": "RI", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "RI", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "SC", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "SC", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "SC", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "SC", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "SC", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "SC", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "SC", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "SD", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "TN", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "TN", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "TN", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "TN", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "TN", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "TN", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "TN", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "TN", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "TX", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "TX", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "TX", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "TX", "district_num": "12", "alt_district_val": "12th District"},
	{"state": "TX", "district_num": "13", "alt_district_val": "13th District"},
	{"state": "TX", "district_num": "14", "alt_district_val": "14th District"},
	{"state": "TX", "district_num": "15", "alt_district_val": "15th District"},
	{"state": "TX", "district_num": "16", "alt_district_val": "16th District"},
	{"state": "TX", "district_num": "17", "alt_district_val": "17th District"},
	{"state": "TX", "district_num": "18", "alt_district_val": "18th District"},
	{"state": "TX", "district_num": "19", "alt_district_val": "19th District"},
	{"state": "TX", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "TX", "district_num": "20", "alt_district_val": "20th District"},
	{"state": "TX", "district_num": "21", "alt_district_val": "21st District"},
	{"state": "TX", "district_num": "22", "alt_district_val": "22nd District"},
	{"state": "TX", "district_num": "23", "alt_district_val": "23rd District"},
	{"state": "TX", "district_num": "24", "alt_district_val": "24th District"},
	{"state": "TX", "district_num": "25", "alt_district_val": "25th District"},
	{"state": "TX", "district_num": "26", "alt_district_val": "26th District"},
	{"state": "TX", "district_num": "27", "alt_district_val": "27th District"},
	{"state": "TX", "district_num": "28", "alt_district_val": "28th District"},
	{"state": "TX", "district_num": "29", "alt_district_val": "29th District"},
	{"state": "TX", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "TX", "district_num": "30", "alt_district_val": "30th District"},
	{"state": "TX", "district_num": "31", "alt_district_val": "31st District"},
	{"state": "TX", "district_num": "32", "alt_district_val": "32nd District"},
	{"state": "TX", "district_num": "33", "alt_district_val": "33rd District"},
	{"state": "TX", "district_num": "34", "alt_district_val": "34th District"},
	{"state": "TX", "district_num": "35", "alt_district_val": "35th District"},
	{"state": "TX", "district_num": "36", "alt_district_val": "36th District"},
	{"state": "TX", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "TX", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "TX", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "TX", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "TX", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "TX", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "UT", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "UT", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "UT", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "UT", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "VA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "VA", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "VA", "district_num": "11", "alt_district_val": "11th District"},
	{"state": "VA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "VA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "VA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "VA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "VA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "VA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "VA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "VA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "VT", "district_num": "0", "alt_district_val": "At-large"},
	{"state": "WA", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "WA", "district_num": "10", "alt_district_val": "10th District"},
	{"state": "WA", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "WA", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "WA", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "WA", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "WA", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "WA", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "WA", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "WA", "district_num": "9", "alt_district_val": "9th District"},
	{"state": "WI", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "WI", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "WI", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "WI", "district_num": "4", "alt_district_val": "4th District"},
	{"state": "WI", "district_num": "5", "alt_district_val": "5th District"},
	{"state": "WI", "district_num": "6", "alt_district_val": "6th District"},
	{"state": "WI", "district_num": "7", "alt_district_val": "7th District"},
	{"state": "WI", "district_num": "8", "alt_district_val": "8th District"},
	{"state": "WV", "district_num": "1", "alt_district_val": "1st District"},
	{"state": "WV", "district_num": "2", "alt_district_val": "2nd District"},
	{"state": "WV", "district_num": "3", "alt_district_val": "3rd District"},
	{"state": "WY", "district_num": "0", "alt_district_val": "At-large"}
];

// This drives the order of the categories on the map page (right side vertical ribbon)
export const CONGRESS_COMMUNITIES = [
	{id: 3, alt_name: 'Housing', name: 'Housing Affordability', count: 1234, color: 'dark-purple', font_color: 'white'},
	{id: 2, alt_name: 'Small Business', name: 'Small Business Growth', count: 749, color: 'violet', font_color: 'white'},
	{id: 0, alt_name: 'Environment', name: 'Environment', count: 255, color: 'dark-pink', font_color: 'white'},
	{id: 1, alt_name: 'Financial Education', name: 'Financial Health', count: 775, color: 'dark-coral', font_color: 'white'},
	{id: 4, alt_name: 'Education', name: 'Education', count: 858, color: 'pink', font_color: 'black'},
	{id: 5, alt_name: 'Civic Engagement', name: 'Civic Engagement', count: 446, color: 'coral', font_color: 'black'},
	{id: 6, alt_name: 'Arts', name: 'Arts and Culture', count: 218, color: 'dark-indigo', font_color: 'white'},
	{id: 7, alt_name: 'Workforce Development', name: 'Workforce Development', count: 253, color: 'indigo', font_color: 'black'},
	{id: 8, alt_name: 'Human and Social Services', name: 'Human and Social Services', count: 1098, color: 'orange', font_color: 'black'},
];

export const CONGRESS_COLORS = {
	0: {
		name: 'Environment',
		color: 'dark-pink',
		font_color: 'white',
	},
	1: {
		name: 'Financial Education',
		color: 'dark-coral',
		font_color: 'white',
	},
	2: {
		name: 'Small Business',
		color: 'violet',
		font_color: 'white',
	},
	3: {
		name: 'Housing',
		color: 'dark-purple',
		font_color: 'white',
	},
	4: {
		name: 'Education',
		color: 'pink',
		font_color: 'black',
	},
	5: {
		name: 'Civic Engagement',
		color: 'coral',
		font_color: 'black',
	},
	6: {
		name: 'Arts',
		color: 'dark-indigo',
		font_color: 'white',
	},
	7: {
		name: 'Workforce Development',
		color: 'indigo',
		font_color: 'black',
	},
	8: {
		name: 'Human and Social Services',
		color: 'orange',
		font_color: 'black',
	},
};

export const IDS_TO_COMMUNITIES = {
	0: 'Environment',
	1: 'Financial Education',  // Financial Health
	2: 'Small Business',
	3: 'Housing',
	4: 'Education',
	5: 'Civic Engagement',
	6: 'Arts',
	7: 'Workforce Development',    // Workforce Development
	8: 'Human and Social Services', // Human and Social Services
};

export const IDS_TO_GA_COMMUNITIES = {
	0: 'environment',
	1: 'financial_education',
	2: 'small_business',
	3: 'housing',
	4: 'education',
	5: 'civic_engagement',
	6: 'arts_culture',
	7: 'workforce_development',    // Workforce Development
	8: 'social_services', // Human and Social Services
};


export const COMMUNITIES_TO_NAMES = {
	'Environment': 'Environment',
	'Financial Education': 'Financial Health',
	'Small Business': 'Small Business Growth',
	'Housing': 'Housing Affordability',
	'Education': 'Education',
	'Civic Engagement': 'Civic Engagement',
	'Arts': 'Arts and Culture',
	'Workforce Development': 'Workforce Development',        // Workforce Development
	'Human and Social Services': 'Human and Social Services',  // Human and Social Services
};


export const COMMUNITIES_TO_NAMES_SPANISH = {
	'Environment': 'Medio ambiente',
	'Financial Education': 'Bienestar financiero',
	'Small Business': 'Crecimiento de pequeñas empresas',
	'Housing': 'Asequibilidad de viviendas',
	'Education': 'Educación',
	'Civic Engagement': 'Participación cívica',
	'Arts': 'Artes y cultura',
	'Workforce Development': 'Desarrollo de la fuerza laboral',
	'Human and Social Services': 'Servicios Humanos y Sociales',
};

export const IDS_TO_ORGCOUNT = {
	'Environment': 247,
	'Financial Education': 767,
	'Small Business': 649,
	'Housing': 1211,
	'Education': 366,
	'Civic Engagement': 265,
	'Arts': 113,
	'Workforce Development': 180,
	'Social Services': 511,
};

export const COLORS = {
	0: 'dark-pink',
	1: 'dark-coral',
	2: 'violet',
	3: 'dark-purple',
	4: 'pink',
	5: 'coral',
	6: 'dark-indigo',
	7: 'indigo',
	8: 'orange',
};

///////////////////////// CATEGORY ORDER IN DROP DOWNS //////////////////////////
// This array drives how each category is ordered in the CATEGORY DROP DOWNS
// These are the category ID numbers.
/////////////////////////////////////////////////////////////////////////////////
const CATEGORY_UI_ORDER = [3, 2, 0, 1, 4, 5, 6, 7, 8];

export const COMMUNITIES_TO_COLORS = {};

Object.keys(IDS_TO_COMMUNITIES).forEach((item, index) => {
	COMMUNITIES_TO_COLORS[IDS_TO_COMMUNITIES[CATEGORY_UI_ORDER[index]]] = COLORS[CATEGORY_UI_ORDER[index]];
});

export const getCommunityId = value =>
	Object.keys(IDS_TO_COMMUNITIES).find(key => IDS_TO_COMMUNITIES[key].toLowerCase() === value.toLowerCase());

export const RESULTS_PER_PAGE = 10;

// These are Mapbox Tileset IDs
export const ORGS_TO_MAP_IDS = {
	'arts': 'jacobhanson.0mnhg9fc',
	'civic-engagement': 'jacobhanson.arrqywti',
	'education': 'jacobhanson.2mj7gl4y',
	'environment': 'jacobhanson.8tp7lfrm',
	'financial-education': 'jacobhanson.b18ia5lt',
	'housing': 'jacobhanson.3osw41hl',
	'job-training': 'jacobhanson.cq6totkr',
	'small-business': 'jacobhanson.33wd4hsg',
	'social-services': 'jacobhanson.80v6wal9',
};

// These are Mapbox Style URLs
export const ORGS_TO_STYLE_URLS = {
	'arts': 'mapbox://styles/jacobhanson/cm8z9r5fb004b01s0ccf0gmar',
	'civic-engagement': 'mapbox://styles/jacobhanson/cm8z9sbxd00as01qs3bgch3sv',
	'education': 'mapbox://styles/jacobhanson/cm8z9sbxd00as01qs3bgch3sv',
	'environment': 'mapbox://styles/jacobhanson/cm8z9uim900at01qs8y7i1swz',
	'financial-education': 'mapbox://styles/jacobhanson/cm8z9w908004f01s031lh8p0b',
	'housing': 'mapbox://styles/jacobhanson/cm8z9v33j001601ru36b1aywu',
	'job-training': 'mapbox://styles/jacobhanson/cm8z9t5tv004d01s0g726bwsa',
	'small-business': 'mapbox://styles/jacobhanson/cm8z9vq5t004p01sbhte82ro2',
	'social-services': 'mapbox://styles/jacobhanson/cm8z9tr5m004o01sb47a72g45',
	'default': 'mapbox://styles/jacobhanson/cm9hjl4b4002t01s574wt8nnx',
};

export const getMapboxKey = key => IDS_TO_COMMUNITIES[key].toLowerCase().replace(/ /g, '-');
export const formatMapboxKey = key => key.toLowerCase().replace(/ /g, '-');

export const getMapboxId = id => `organizations-${getMapboxKey(id)}`;
export const formatMapboxId = id => `organizations-${id.toLowerCase().replace(/ /g, '-')}`;
export const getMapboxIdFromOrgDash = orgDash => {
	const lowerText = orgDash.replace(/organizations-/g, '').replace(/-/, ' ');
	return getCommunityId(lowerText);
};


export const CATEGORY_IDS_TO_META_DESC = {
	'': 'Wells Fargo supports over 10,000 local and national organizations focusing on financial health, affordable housing, sustainability, and more.',
	'housing': 'focused on making home ownership and rentals more accessible.',
	'financial-education': 'that use education & innovation to help increase financial success.',
	'small-business': 'that are investing in local businesses and entrepreneurs.',
	'education': 'that are providing educational resources for success.',
	'environment': 'that are focusing on sustainability and environmental conservation.',
	'civic-engagement': 'that are making a difference in the civic life of our communities.',
	'arts': 'that are helping preserve, share, and develop arts and culture.',
	'job-training': 'that are providing job opportunities and training.',
	'social-services': 'that are improving equality & quality of life within communities.'
}

export const DEFAULT_BOUNDS = {
	minLat: 25,
	maxLat: 51,
	minLong: -65.5,
	maxLong: -143.5,
}

const object = {
	key: (n) => this[Object.keys(this)[n]],
};

export const keyByIndex = (obj, idx) => object.key.call(obj, idx);

export const WF_OWNED_SITES = [
	"wellsfargo.com",
	"wf.com",
	"wellsfargoassetmanagement.com",
	"wellsfargoadvisors.com",
	"wellsfargomedia.com",
	"localhost:3000",
	// "facebook.com/wellsfargo",
	// "youtube.com/user/wellsfargo",
	// "linkedin.com/company/wellsfargo",
	// "instagram.com/wellsfargo",
	// "pinterest.com/wellsfargo",
	// "twitter.com/wellsfargo",
]

export const EXIT_OVERLAY_EXCEPTIONS = [
	"https://www.facebook.com/sharer/",
	"https://twitter.com/intent/tweet",
	"https://www.linkedin.com/sharing/share-offsite/",
	"https://www.linkedin.com/shareArticle?mini=true&url="
]

export const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;

export const getZoom = () => window.devicePixelRatio || window.screen.availWidth / document.documentElement.clientWidth;

export const isMobileDevice = () => {
	const userAgent = window.navigator.userAgent.toLowerCase();
	return (userAgent.indexOf('iphone') > -1 || userAgent.indexOf('ipad') > -1 || userAgent.indexOf('android') > -1);
}

export const isMobileUI = (breakpoint = 768) => window.innerWidth < breakpoint
